import Vue from 'vue';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';

Vue.config.productionTip = false;

Vue.use(CludoVue, {
  store: store,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 11278,
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 500,
    paginationRange: 2,
    sortOnLoad: { Title: 'asc' },
    payload: {
      filters: {
        Category: ['Postgraduate'],
        StudyLevel: ['Postgraduate'],
        StudyYear: ['2026', '2027'],
      },
    },
  },
});

new Vue({
  render: (h) => h(App),
  store: store,
}).$mount('#pg-programme-search');
